import { __read } from "tslib";
import equal from 'fast-deep-equal';
import { useEffect, useMemo, useState } from 'react';
import { useOfficeComponentContext } from './useOfficeComponentContext';
// TODO: Use react router hooks rather than component context
export var useCurrentRoute = function () {
    var officeComponentContext = useOfficeComponentContext().data;
    var _a = __read(useState(officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.router.getCurrentRoute()), 2), officeRouteItem = _a[0], setOfficeRouteItem = _a[1];
    useEffect(function () {
        var componentContext = officeComponentContext;
        var routeObservable = componentContext === null || componentContext === void 0 ? void 0 : componentContext.router.getRouteObservable();
        var subscription = routeObservable === null || routeObservable === void 0 ? void 0 : routeObservable.subscribe(function (newRoute) {
            setOfficeRouteItem(function (currentRoute) {
                if (equal(currentRoute, newRoute)) {
                    return currentRoute;
                }
                return newRoute;
            });
        });
        return function () {
            if (subscription) {
                subscription.unsubscribe();
            }
        };
    }, [officeComponentContext]);
    return useMemo(function () {
        return officeRouteItem;
    }, [officeRouteItem]);
};
//# sourceMappingURL=useCurrentRoute.js.map